import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <h1 className="!font-bold !text-2xl text-blue-400">Wavelengths Lighting</h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className="text-gray-200 hover:text-blue-400 transition-colors duration-200 font-medium">Services</button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-200 hover:text-blue-400 transition-colors duration-200 font-medium">Gallery</button>
            <button onClick={() => scrollToSection('tree-wrapping')} className="text-gray-200 hover:text-blue-400 transition-colors duration-200 font-medium">Tree Wrapping</button>
            <button onClick={() => scrollToSection('diy')} className="text-gray-200 hover:text-blue-400 transition-colors duration-200 font-medium">DIY</button>
            <Button onClick={() => scrollToSection('quote')} className="bg-blue-500 hover:bg-blue-600 text-white font-semibold">
              Get a Quote
            </Button>
            <Button asChild className="bg-green-600 hover:bg-green-700 text-white font-semibold">
              <a href="tel:306-250-4647">Call Now</a>
            </Button>
          </nav>

          {/* Mobile: Call Now Button and Menu Button */}
          <div className="flex items-center gap-3 md:hidden">
            <Button asChild size="sm" className="bg-green-600 hover:bg-green-700 text-white font-semibold">
              <a href="tel:306-250-4647">Call</a>
            </Button>
            <button
              className="text-white"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden pb-4 space-y-3">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-200 hover:text-blue-400 py-2">Services</button>
            <button onClick={() => scrollToSection('gallery')} className="block w-full text-left text-gray-200 hover:text-blue-400 py-2">Gallery</button>
            <button onClick={() => scrollToSection('tree-wrapping')} className="block w-full text-left text-gray-200 hover:text-blue-400 py-2">Tree Wrapping</button>
            <button onClick={() => scrollToSection('diy')} className="block w-full text-left text-gray-200 hover:text-blue-400 py-2">DIY</button>
            <Button onClick={() => scrollToSection('quote')} className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold">
              Get a Quote
            </Button>
            <Button asChild className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold">
              <a href="tel:306-250-4647">Call Now: 306-250-4647</a>
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
